"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.StyledTableWrapper = exports.StyledTableScrollWrapper = exports.StyledTableData = exports.StyledTable = exports.StyledRowHeader = exports.StyledRightFadeOverlay = exports.StyledLeftFadeOverlay = exports.StyledFadeOverlayWrapper = exports.StyledCellText = exports.StyledCellIconWrapper = exports.StyledCaption = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridConfig = require("../../fuse-responsive-grid/src/grid-config");
var _typography = require("../../fuse-typography-element/src/typography");
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledTableWrapper = exports.StyledTableWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-table'
}).withConfig({
  displayName: "styled-table__StyledTableWrapper",
  componentId: "sc-139v5m3-0"
})(["overflow-x:auto;"]);
var StyledTitle = exports.StyledTitle = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-table__title'
}).withConfig({
  displayName: "styled-table__StyledTitle",
  componentId: "sc-139v5m3-1"
})(["margin-bottom:var(--spacing-global-space5);"]);
var StyledTableScrollWrapper = exports.StyledTableScrollWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-table__table-scroll-wrapper'
}).withConfig({
  displayName: "styled-table__StyledTableScrollWrapper",
  componentId: "sc-139v5m3-2"
})(["overflow-x:auto;overflow-y:hidden;position:relative;&:focus{outline:var(--border-radius-s) solid var(--color-functional-focus);outline-offset:-2px;}"]);
var StyledTable = exports.StyledTable = _styledComponents["default"].table.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['alignment', 'border', 'hasColumnHeaders', 'layout'].includes(prop);
  }
}).attrs({
  className: 'fuse-table__table'
}).withConfig({
  displayName: "styled-table__StyledTable",
  componentId: "sc-139v5m3-3"
})(["", ""], function (_ref) {
  var alignment = _ref.alignment,
    border = _ref.border,
    hasColumnHeaders = _ref.hasColumnHeaders,
    layout = _ref.layout;
  return "\n\t\twidth: 100%;\n\t\ttable-layout: ".concat(_config["default"][layout].layout, ";\n\n\t\tborder-collapse: collapse;\n\t\ttext-align: ").concat(alignment === 'left' ? 'left' : 'center', ";\n\n\t\tthead {\n\t\t\tth {\n\t\t\t\twhite-space: ").concat(_config["default"][layout].columnWrap, ";\n\t\t\t}\n\t\t}\n\n\t\ttbody tr:nth-child(").concat(hasColumnHeaders ? 'odd' : 'even', ") {\n\t\t\tbackground: var(--color-global-grey200);\n\t\t}\n\n\t\ttbody {\n\t\t\ttr {\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--color-global-grey300);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tth {\n\t\t\tpadding: var(--spacing-global-space3);\n\t\t\tvertical-align: top;\n\n\t\t\t@media screen and (min-width: ").concat(_gridConfig.gridConfig.m.minWidth, ") {\n\t\t\t\tpadding: var(--spacing-global-space4) var(--spacing-global-space5);\n\t\t\t}\n\t\t}\n\n\t\tth,\n\t\ttd {\n\t\t\tborder: ").concat(border ? 'var(--border-width-xs) solid var(--color-functional-divider)' : 'initial', ";\n\t\t\twidth: ").concat(_config["default"][layout].width.xxs, ";\n\t\t\tmin-width: ").concat(_config["default"][layout].minWidth.xxs, ";\n\n\t\t\t@media screen and (min-width: ").concat(_gridConfig.gridConfig.m.minWidth, ") {\n\t\t\t\twidth: ").concat(_config["default"][layout].width.m, ";\n\t\t\t\tmin-width: ").concat(_config["default"][layout].minWidth.m, ";\n\t\t\t}\n\t\t}\n\t");
});
var StyledCaption = exports.StyledCaption = _styledComponents["default"].caption.attrs({
  className: 'fuse-table__table-caption'
}).withConfig({
  displayName: "styled-table__StyledCaption",
  componentId: "sc-139v5m3-4"
})(["caption-side:top;"]);
var StyledRowHeader = exports.StyledRowHeader = _styledComponents["default"].th.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['leftAlign'].includes(prop);
  }
}).attrs({
  className: 'fuse-table__table-row-header'
}).withConfig({
  displayName: "styled-table__StyledRowHeader",
  componentId: "sc-139v5m3-5"
})(["text-align:", ";"], function (_ref2) {
  var leftAlign = _ref2.leftAlign;
  return leftAlign ? 'left' : 'inherit';
});
var StyledTableData = exports.StyledTableData = _styledComponents["default"].td.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hasCellIcon', 'vAlignMiddle'].includes(prop);
  }
}).attrs({
  className: 'fuse-table__table-data'
}).withConfig({
  displayName: "styled-table__StyledTableData",
  componentId: "sc-139v5m3-6"
})(["", ""], function (_ref3) {
  var hasCellIcon = _ref3.hasCellIcon,
    vAlignMiddle = _ref3.vAlignMiddle;
  return hasCellIcon ? "\n\t\t\t\tpadding: var(--spacing-global-space2) var(--spacing-global-space3);\n\t\t\t\tvertical-align: middle;\n\n\t\t\t\t@media screen and (min-width: ".concat(_gridConfig.gridConfig.m.minWidth, ") {\n\t\t\t\t\tpadding: var(--spacing-global-space3) var(--spacing-global-space5);\n\t\t\t\t}\n\t\t\t") : "\n\t\t\t\tpadding: var(--spacing-global-space3);\n\t\t\t\tvertical-align: ".concat(vAlignMiddle ? 'middle' : 'top', ";\n\n\t\t\t\t@media screen and (min-width: ").concat(_gridConfig.gridConfig.m.minWidth, ") {\n\t\t\t\t\tpadding: var(--spacing-global-space4) var(--spacing-global-space5);\n\t\t\t\t}\n\t\t\t");
});
var StyledCellText = exports.StyledCellText = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-table__table-cell-text'
}).withConfig({
  displayName: "styled-table__StyledCellText",
  componentId: "sc-139v5m3-7"
})(["margin-bottom:0;"]);
var StyledCellIconWrapper = exports.StyledCellIconWrapper = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['alignment'].includes(prop);
  }
}).attrs({
  className: 'fuse-table__table-cell-icon-wrapper'
}).withConfig({
  displayName: "styled-table__StyledCellIconWrapper",
  componentId: "sc-139v5m3-8"
})(["display:flex;justify-content:", ";"], function (_ref4) {
  var alignment = _ref4.alignment;
  return alignment === 'left' ? 'start' : 'center';
});
var StyledFadeOverlayWrapper = exports.StyledFadeOverlayWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-table__table-fade-overlay-wrapper'
}).withConfig({
  displayName: "styled-table__StyledFadeOverlayWrapper",
  componentId: "sc-139v5m3-9"
})(["position:sticky;top:0;left:0;width:100%;height:100%;margin-right:-100%;pointer-events:none;z-index:1;"]);
var StyledOverlay = _styledComponents["default"].div.withConfig({
  displayName: "styled-table__StyledOverlay",
  componentId: "sc-139v5m3-10"
})(["position:absolute;top:0;width:calc(2.5rem * 1.6);height:100%;background:linear-gradient(270deg,var(--color-global-white) 0%,rgba(255,255,255,0) 100%);pointer-events:auto;"]);
var StyledLeftFadeOverlay = exports.StyledLeftFadeOverlay = (0, _styledComponents["default"])(StyledOverlay).attrs({
  className: 'fuse-table__table-fade-overlay--left'
}).withConfig({
  displayName: "styled-table__StyledLeftFadeOverlay",
  componentId: "sc-139v5m3-11"
})(["left:0;rotate:180deg;"]);
var StyledRightFadeOverlay = exports.StyledRightFadeOverlay = (0, _styledComponents["default"])(StyledOverlay).attrs({
  className: 'fuse-table__table-fade-overlay--right'
}).withConfig({
  displayName: "styled-table__StyledRightFadeOverlay",
  componentId: "sc-139v5m3-12"
})(["right:0;"]);